class GltheaaAnnouncementBar extends HTMLElement {
  constructor() {
    super();
    this.pause = this.pause.bind(this);
    this.play = this.play.bind(this);
  }

  connectedCallback() {
    if (this.dataset.pauseOnHover !== 'true') return;

    this.addEventListener('mouseenter', this.pause);
    this.addEventListener('mouseleave', this.play);
    this.addEventListener('focusin', this.pause);
    this.addEventListener('focusout', this.play);
  }

  disconnectedCallback() {
    this.removeEventListener('mouseenter', this.pause);
    this.removeEventListener('mouseleave', this.play);
    this.removeEventListener('focusin', this.pause);
    this.removeEventListener('focusout', this.play);
  }

  pause() {
    this.classList.add('is-paused');
  }

  play() {
    this.classList.remove('is-paused');
  }
}

customElements.define('gltheaa-announcement-bar', GltheaaAnnouncementBar);
